import { teamCompetitionSharedState } from './team/competition/teamCompetition.sharedstate';
import { teamSharedState } from './team/team.sharedstate';

export const sharedStates = {
  team: teamSharedState,
  teamCompetition: teamCompetitionSharedState,
};
